<template>
  <div class="form-group">
    <label>{{ this.labelDesc }}</label>
      <div
        class="btn-group btn-group-sm"
        role="group"
        aria-label="Basic example"
      >
        <button
          type="button"
          :class="[value === 'left' ? 'btn-info' : 'btn-outline-info' , 'btn btn-small']"
          value="left"
          @click="changeValue('left')"
        >
          <font-awesome-icon v-if="icons" class="font-awesome-icon" :icon="['fas', 'align-left']"/>
          <span v-else>{{ $t('ct-align-left') }}</span>
        </button>

        <button
          type="button"
          :class="[value === 'center' ? 'btn-info' : 'btn-outline-info' , 'btn btn-small']"
          value="center"
          @click="changeValue('center')"
        >
          <font-awesome-icon v-if="icons" class="font-awesome-icon" :icon="['fas', 'align-center']"/>
          <span v-else>{{ $t('ct-align-center') }}</span>
        </button>

        <button
          type="button"
          :class="[value === 'right' ? 'btn-info' : 'btn-outline-info' , 'btn btn-small']"
          value="right"
          @click="changeValue('right')"
        >
          <font-awesome-icon v-if="icons" class="font-awesome-icon" :icon="['fas', 'align-right']"/>
          <span v-else>{{ $t('ct-align-right') }}</span>
        </button>

        <button
          v-show="'alignMobile' == name"
          type="button"
          :class="[value === 'justify' ? 'btn-info' : 'btn-outline-info' , 'btn btn-small']"
          value="justify"
          @click="changeValue('justify')"
        >
          <font-awesome-icon v-if="icons" class="font-awesome-icon" :icon="['fas', 'align-justify']"/>
          <span v-else>{{ $t('ct-align-justify') }}</span>
        </button>

      </div>
  </div>
</template>

<script>
export default {
  name: 'AlignMenuComponent',
  components: {},
	props: {
		icons: false,
	},
  data() {
    return {
      valueDesc: 0,
      labelDesc: 'opa',
      callback: null,
      name: null,
      value: null,
    };
  },
  methods: {
    changeValue(val) {
      this.value = val;
      this.callback();
    },
    setValues(obj, elem) {
      this.name = obj.name;
      this.element = elem;
      this.value = obj.defaultValue || 'right';
      this.valueDesc = this.value;
      this.labelDesc = obj.labelDesc ? this.$t(`ct-${obj.labelDesc}`) : this.$t(`ct-align-menu`);

      this.callback = obj.callback;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/resources/AlignMenu.vue